export default[
    {
        path: '/folhar/cadastro',
        name: 'cadastro da folhar', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/folhar/lista',
        name: 'lista da folhar', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/folhar/editar/:id',
        name: 'editar folhar', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]